import React, { useState } from 'react'
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Box,
  Card,
  CardContent,
  Typography,
} from '@mui/material'
import { styled } from '@mui/material/styles'
import LinkItemDialog from './LinkItemDialog'
import { useTranslation } from 'react-i18next' // LAP-733 (GE022)

// LAP-733 (GE022): labels resolved via t() at render time
const ENGAGEMENT_OPTIONS = [
  { emoji: '🎯', labelKey: 'engageLinkGoal',    descKey: 'engageLinkGoalDesc',    action: 'goal' },
  { emoji: '🧩', labelKey: 'engageLinkProject', descKey: 'engageLinkProjectDesc', action: 'project' },
  { emoji: '✅', labelKey: 'engageLinkTask',    descKey: 'engageLinkTaskDesc',    action: 'task' },
]

const EngagementCard = styled(Card)(({ theme }) => ({
  cursor: 'pointer',
  border: '2px solid rgba(255, 255, 255, 0.2)',
  backgroundColor: 'rgba(255, 255, 255, 0.05)',
  transition: 'all 0.3s ease',
  '&:hover': {
    backgroundColor: 'rgba(255, 255, 255, 0.1)',
    borderColor: 'rgba(255, 255, 255, 0.4)',
    transform: 'translateY(-2px)',
  },
}))

const EngagementPopup = ({ open, onClose, ideaId, onLinkCreated }) => {
  const { t } = useTranslation('layout') // LAP-733 (GE022)
  const [showLinkDialog, setShowLinkDialog] = useState(false)
  const [selectedLinkType, setSelectedLinkType] = useState(null)

  const handleOptionClick = (action) => {
    setSelectedLinkType(action)
    setShowLinkDialog(true)
  }

  const handleLinkDialogClose = () => {
    setShowLinkDialog(false)
    setSelectedLinkType(null)
  }

  const handleLinkCreated = () => {
    if (onLinkCreated) {
      onLinkCreated()
    }
    handleLinkDialogClose()
    onClose()
  }

  return (
    <Dialog
      open={open}
      onClose={onClose}
      maxWidth="md"
      fullWidth
      PaperProps={{
        sx: {
          background: 'rgba(0, 0, 29, 0.95)',
          backdropFilter: 'blur(10px)',
          borderRadius: '16px',
        },
      }}
    >
      <DialogTitle
        sx={{
          color: 'white',
          fontSize: '1.5rem',
          fontWeight: 500,
        }}
      >
        {t('roadmap.engageTitle')}
      </DialogTitle>
      <DialogContent
        sx={{
          // Custom scrollbar styling (Word/Google Docs style)
          '&::-webkit-scrollbar': {
            width: '8px',
          },
          '&::-webkit-scrollbar-track': {
            background: 'rgba(255, 255, 255, 0.05)',
            borderRadius: '4px',
          },
          '&::-webkit-scrollbar-thumb': {
            background: 'rgba(255, 255, 255, 0.3)',
            borderRadius: '4px',
            '&:hover': {
              background: 'rgba(255, 255, 255, 0.5)',
            },
          },
          // Firefox scrollbar
          scrollbarWidth: 'thin',
          scrollbarColor: 'rgba(255, 255, 255, 0.3) rgba(255, 255, 255, 0.05)',
        }}
      >
        <Typography
          variant="body2"
          sx={{ color: 'rgba(255, 255, 255, 0.7)', mb: 3 }}
        >
          {t('roadmap.engageHelper')}
        </Typography>

        <Box sx={{ display: 'flex', flexDirection: 'column', gap: 2 }}>
          {ENGAGEMENT_OPTIONS.map((option, index) => (
            <EngagementCard
              key={index}
              onClick={() => handleOptionClick(option.action)}
            >
              <CardContent>
                <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
                  <Typography
                    variant="h4"
                    sx={{
                      fontSize: '2rem',
                    }}
                  >
                    {option.emoji}
                  </Typography>
                  <Box>
                    <Typography
                      variant="h6"
                      sx={{
                        color: 'white',
                        fontWeight: 500,
                        mb: 0.5,
                      }}
                    >
                      {t('roadmap.' + option.labelKey)}
                    </Typography>
                    <Typography
                      variant="body2"
                      sx={{
                        color: 'rgba(255, 255, 255, 0.7)',
                      }}
                    >
                      {t('roadmap.' + option.descKey)}
                    </Typography>
                  </Box>
                </Box>
              </CardContent>
            </EngagementCard>
          ))}
        </Box>
      </DialogContent>
      <DialogActions sx={{ p: 2 }}>
        <Button onClick={onClose} sx={{ color: 'rgba(255, 255, 255, 0.7)' }}>
          {t('roadmap.engageDecideLater')}
        </Button>
      </DialogActions>

      <LinkItemDialog
        open={showLinkDialog}
        onClose={handleLinkDialogClose}
        ideaId={ideaId}
        onLinkCreated={handleLinkCreated}
      />
    </Dialog>
  )
}

export default EngagementPopup

